"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const react_1 = require("react");
const defaultMessages_1 = require("../constants/defaultMessages");
exports.initialState = {
    messages: defaultMessages_1.defaultMessages,
};
const FooterContext = (0, react_1.createContext)({
    state: exports.initialState,
    dispatch: () => {
        /* noop */
    },
});
exports.default = FooterContext;
//# sourceMappingURL=footerContext.js.map